export default __webpack_public_path__ + "img/t3_1.03eff52e.png";